const translations = {
    addNotes: 'Add notes (optional)',
    chooseCalibrationType: 'Choose a calibration type',
    choosePart: 'Choose a part',
    chooseUnit: 'Choose a unit',
    photos: 'Photos'
};

export default translations;
